import { useViewModeTransition } from '../../context/ViewModeTransitionContext.tsx';
import { LoadingSpinner } from '../loading/LoadingSpinner.tsx';

export const ViewModeTransitionOverlay = () => {
  const { isTransitioning } = useViewModeTransition();

  return (
    <div
      aria-hidden={!isTransitioning}
      style={{
        position: 'absolute',
        inset: 0,
        zIndex: 30,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(16, 16, 16, 0.45)',
        backdropFilter: 'blur(14px) saturate(120%)',
        WebkitBackdropFilter: 'blur(14px) saturate(120%)',
        opacity: isTransitioning ? 1 : 0,
        pointerEvents: isTransitioning ? 'auto' : 'none',
        transition: 'opacity 200ms ease',
      }}
    >
      <LoadingSpinner size={56} />
    </div>
  );
};
